
























































import { Component, Prop, Vue, Watch, Ref } from "vue-property-decorator";
import http from "@/axios/http-common";
import { DiagItem } from "@/types/diag_procedure";

@Component
export default class DiagItemRow extends Vue {
  @Prop({
    default: null
  })
  item: DiagItem;

  @Prop({
    default: null
  })
  index: number;

  @Ref() rowDiag: HTMLInputElement;

  icd = null;
  diag = null;
  kasus = null;
  selected = null;
  level = null;

  searchString = null;
  searchDiagLoading = false;

  diagnosa = [];

  _timerId;

  get jenisOption() {
    return [
      {
        id: "p",
        label: "Primer"
      },
      {
        id: "s",
        label: "Sekunder"
      }
    ];
  }

  get levelText() {
    const opt = this.jenisOption.find(item => item.id === this.level);

    return opt?.label ?? "-";
  }

  // get isPrimary() {
  //   console.log("set is primary", this.item, this.item.level);
  //   return this.item.level;
  // }

  // set isPrimary(val) {
  //   this.$emit("setLevel", val, this.index);
  // }

  mounted() {
    this.changedItem(this.item);
  }

  focus() {
    this.rowDiag.focus();
  }

  itemChangeDiag(val) {
    const isString = typeof val == "string";

    if (isString) {
      this.diag = this.selected;
      this.icd = null;
    } else {
      this.diag = this.selected.dx;
      this.icd = this.selected.kddx;
    }

    this.searchString = "";

    this.$emit("selectedItem", {
      diag: this.diag,
      icd: this.icd
    });
  }

  add() {
    this.$emit("add");
  }

  remove() {
    this.$emit("remove");
  }

  searchDiag(termSearch) {
    this.searchDiagLoading = true;

    http
      .getDataParam("/referensi/diagnosis-icd/search", {
        params: { term: termSearch }
      })
      .then(res => {
        this.diagnosa = res.data;
      })
      .finally(() => {
        this.searchDiagLoading = false;
      });
  }

  @Watch("searchString")
  searched() {
    this.diagnosa = [];

    if (this.searchString === null) {
      this.icd = null;
    }

    clearTimeout(this._timerId);

    this._timerId = setTimeout(() => {
      if (this.searchString === null || this.searchString.length < 2) return;
      if (this.diag === this.searchString) return;

      this.searchDiag(this.searchString);
    }, 500);
  }

  @Watch("item", { deep: true })
  changedItem(val: DiagItem) {
    this.icd = val.icd;
    this.diag = val.diag;
    this.selected = val.diag;
    this.kasus = val.kasus;
    this.level = val.level;

    this.$emit("changeData", val, this.index);
    // this.$emit("setLevel", this.level, this.index);
  }

  @Watch("kasus", { deep: true })
  changedKasus(val) {
    this.item.kasus = val;
    // this.$emit("changeData", );
  }
}
